<div [style.display]="'block'">
  <div>
    <div class="text-left" *ngIf="bookingProgramDropdownStatus">
      <mat-form-field style="width:100%;">
        <mat-label>Select booking Prepay
          <span>({{bookingProgramDropdownRequired}})</span>
        </mat-label>
        <mat-select class="ta-book-bookingprepaydropdown" [(ngModel)]="bookRemarks.bookingProgram" (selectionChange)="onSelectBookingProgram($event)"
          [disabled]="!bookingProgramDropdownStatus">
          <mat-option value="">Select option</mat-option>
          <mat-option *ngFor="let item of bookingProgramDropdownItems" [value]="item.Value" [ngClass]="'ta-bookingprogram-' + item.Value.replaceAll(' ','-').toLowerCase()">
            {{item.Value}}
          </mat-option>
        </mat-select>
        <span style="color: red;" *ngIf="requiredBookingPrepay">* Select at least one option</span>
      </mat-form-field>

    </div>

    <div style="text-align: left;">
      <mat-checkbox class="ta-book-byphonecall" (change)="changeIsByPhone($event)" [(ngModel)]="bookRemarks.isByPhone"
        color="primary">By Phone Call
      </mat-checkbox>
    </div>
    <mat-form-field class="w-100">
      <mat-label>Remarks</mat-label>
      <textarea matInput class="ta-book-remarks" [maxLength]="maxIncidentDescriptionLength"
        [(ngModel)]="bookRemarks.bookRemarks"></textarea>
      <small class="form-text text-muted">
        <code>{{bookRemarks.bookRemarks.length}}</code> of
        <code>{{maxIncidentDescriptionLength}}</code> characters
      </small>
    </mat-form-field>
    <br>
    <div *ngIf="isSign" class="margin_20" style="border:0px solid rgb(255, 253, 253) !important;">
      <div *ngIf="isSign && !signatureImage">
        <span>
          <span style="color: red; background-color: white;" *ngIf="isSignatureRequired">*signature is required </span>
          <br>
          <app-signature-pad
            #signature
            style="background-color: white !important;"
            [height]="200"
            [minWidth]="5"
            backgroundColor="#ffffff"
            (drawStart)="drawStart()"></app-signature-pad>
          <br>
        </span>
        
        <button mat-button class="text-white btn btn-success" (click)="drawComplete()">Done</button>
         &nbsp;
        <button mat-button class="text-white btn btn-warning pull-right" (click)="clear()">Clear</button>
      </div>
      <div *ngIf="signatureImage">
        <app-signature-pad
          [readonly]="true"
          [height]="200"
          [value]="signatureImage"
          backgroundColor="#ffffff"></app-signature-pad>
        <div>
          <br>
          <button mat-button class="ta-book-resign text-white btn btn-warning" (click)="resign()">
            Re-Sign
          </button>
        </div>
      </div>
      <br>
    </div>
    <br>
    <div>
      <button mat-button class="mat-mdc-button-RedBackground-WhiteText ta-book-cancel magin_5 text-white btn btn-danger" (click)="cancel()">Cancel</button>
      <button [disabled]="isSign" mat-button class="ta-book-sign magin_5 text-white btn btn-info"
        (click)="sign()">Sign</button>

      <button [disabled]="isSignatureRequired" mat-button [ngClass]="'ta-book-finish magin_5 text-white btn btn-'+globals.colorTheme"
        (click)="finishBook()">{{ showFarmAndFields? 'Book Single':'Book'}}</button>
      <button [disabled]="isSignatureRequired" *ngIf="showFarmAndFields" mat-button class="mat-stroked-button-WhiteBackground-GreenText ta-book-split magin_5 color_green"
        (click)="finishSplitBook()">Book Split</button>
    </div>
  </div>
</div>